









import VueOptions from '@utils/VueOptions'
import FormBuilder from '@ui/FormBuilder/FormBuilder'
import SpaceFields from '@ui/FormBuilder/ResourceFields/SpaceFields'

settings =
  name: 'SpaceForm'

  vue:
    props: ['form', 'mediaKits']

    components: {
      FormBuilder,
    }

    computed:
      contextForSpaceFields: ->
        options:
          images: @mediaKits

      spaceFields: ->
        SpaceFields(@contextForSpaceFields)

export default VueOptions.vue settings
